import { useState, FC } from 'react'
import { useForm } from 'react-hook-form'


import { Button, FormLabel, FormLabelError, Radio, Textarea, Title, Text, Icon } from '../UI'
import { survey } from "../../services";
import {useSelector} from "react-redux";


interface ISurveyForm {
  svSuggestion: string,
  svComment: string
}

const Survey = () => {
  const [step, setStep] = useState<number>(1)
  const defaultValues: ISurveyForm = {
    svSuggestion: '',
    svComment: ''
  }

  const { register, handleSubmit, formState: { errors } } = useForm<ISurveyForm>({
    defaultValues
  })

  const userCurrent = useSelector((state: any) => state.userCurrentStorage ? state.userCurrentStorage : {})

  const getInfo = () => {
    const { info } = userCurrent
    return info
  }

  const onSubmit = async (fData: ISurveyForm) => {
    const user = getInfo()
    const data = {
      id: user.id,
      suggestion: fData.svSuggestion,
      comment: fData.svComment
    }
    const resp: any = await survey.registerSurvey(data)
    setStep(2)
  }

  return (
    <div className="p-50" style={{ height: '555px' }}>
      {step === 1 ?
          <div>
            <Title component="h4" weight="bold">¿ En qué podemos mejorar?</Title>

            <form className="mt-30" onSubmit={handleSubmit(onSubmit)}>
              <fieldset>
                <Radio
                  {...register('svSuggestion', { required: 'Selecciona Sugerencia' })}
                  id="svSuggestion1"
                  name="svSuggestion"
                  value="Historial de horas médicas"
                  tabIndex={1}
                  error={!!errors.svSuggestion}
                />
                <FormLabel htmlFor="svSuggestion1">Historial de horas médicas</FormLabel>
              </fieldset>
              <fieldset className="mt-20">
                <Radio
                  {...register('svSuggestion', { required: 'Selecciona Sugerencia' })}
                  id="svSuggestion2"
                  name="svSuggestion"
                  value="Mis exámenes"
                  tabIndex={2}
                  error={!!errors.svSuggestion}
                />
                <FormLabel htmlFor="svSuggestion2">Mis exámenes</FormLabel>
              </fieldset>
              <fieldset className="mt-20">
                <Radio
                  {...register('svSuggestion', { required: 'Selecciona Sugerencia' })}
                  id="svSuggestion3"
                  name="svSuggestion"
                  value="Mi grupo familiar"
                  tabIndex={3}
                  error={!!errors.svSuggestion}
                />
                <FormLabel htmlFor="svSuggestion3">Mi grupo familiar</FormLabel>
              </fieldset>
              <fieldset className="mt-20">
                <Radio
                  {...register('svSuggestion', { required: 'Selecciona Sugerencia' })}
                  id="svSuggestion4"
                  name="svSuggestion"
                  value="Funcionamiento general del Portal"
                  tabIndex={4}
                  error={!!errors.svSuggestion}
                />
                <FormLabel htmlFor="svSuggestion4">Funcionamiento general del Portal</FormLabel>
              </fieldset>
              <fieldset className="mt-20">
                <Radio
                  {...register('svSuggestion', { required: 'Selecciona Sugerencia' })}
                  id="svSuggestion5"
                  name="svSuggestion"
                  value="Proceso de creación de cuenta"
                  tabIndex={5}
                  error={!!errors.svSuggestion}
                />
                <FormLabel htmlFor="svSuggestion5">Proceso de creación de cuenta</FormLabel>

                {errors.svSuggestion && <FormLabelError className="mt-15">{errors.svSuggestion?.message}</FormLabelError>}
              </fieldset>

              <fieldset className="mt-25">
                <Textarea
                  {...register('svComment', { required: 'Digita Comentario' })}
                  id="svComment"
                  name="svComment"
                  placeholder="Agregar comentario"
                  tabIndex={6}
                  fullWidth
                  style={{ minHeight: '120px' }}
                  error={!!errors.svComment}
                />
                {errors.svComment && <FormLabelError>{errors.svComment?.message}</FormLabelError>}
              </fieldset>

              <Button
                type="submit"
                fullWidth
                tabIndex={7}
                className="mt-20"
                onClick={() => null}
              >
                ENVIAR
              </Button>
            </form>
          </div>
        :
          <div className="d-flex align-items-center h-full text-center">
            <div>
              <Icon name="modal-success" />
              <Title component="h4" size="28" color="primary" weight="bold" className="mt-20">¡Muchas gracias!</Title>
              <Text className="mt-20">Estamos trabajando para brindarte una mejor experiencia.</Text>
            </div>
          </div>
      }
    </div>
  )
}

export { Survey }
